// AccountOverlay.jsx - Modal overlay for account management
import React from 'react';

const AccountOverlay = ({ children, onClose }) => {
  return (
    <div
      className="fixed inset-0 z-[1000] bg-black/50 flex items-center justify-center p-4 sm:p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-3xl max-h-[80vh] overflow-y-auto rounded-xl shadow-2xl relative bg-white dark:bg-slate-800"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-md text-2xl leading-none transition-colors text-gray-500 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-700 hover:text-gray-700 dark:hover:text-slate-200"
          aria-label="Close"
        >
          ×
        </button>

        {/* Header */}
        <div className="px-6 sm:px-8 pt-8 pb-5 border-b border-gray-200 dark:border-white/10">
          <h2 className="m-0 text-xl font-semibold text-gray-900 dark:text-slate-100">
            Manage Jira Accounts
          </h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-slate-400">
            Add, activate, or manage your Jira account connections
          </p>
        </div>

        {/* Content */}
        <div className="px-6 sm:px-8 py-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccountOverlay;